import { render, staticRenderFns } from "./LayoutButton.vue?vue&type=template&id=3decaaa1&scoped=true&"
import script from "./LayoutButton.vue?vue&type=script&lang=js&"
export * from "./LayoutButton.vue?vue&type=script&lang=js&"
import style0 from "./LayoutButton.vue?vue&type=style&index=0&id=3decaaa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3decaaa1",
  null
  
)

export default component.exports